<template>
    <div>
        <h2>Oh no, this page doesn't exist!</h2>
        <p>Your link, '{{ link }}', was invalid.</p>
        <button @click="$router.back()">Take me back</button>
        <button @click="$router.push('/')">Go to the homepage</button>
    </div>
</template>

<script>
export default {
    props: ['basicLink'],

    computed: {
        link() {
            return !this.basicLink || this.basicLink == '' ? 'undefined' : window.location.origin + '/' + this.basicLink;
        },
    },
};
</script>


<style scoped>
div {
    padding: 2rem;
}

h2 {
    padding: 5rem;
    padding-bottom: 0;
    font-size: xxx-large;
    color: rgb(13, 37, 119);
}

p {
    margin-bottom: 4rem;
    color: rgb(13, 37, 119);
}

button {
    padding: 1.5rem;
    margin: 1rem;
    width: 250px;
    border-radius: 1rem;
    border: 1px solid;
    background: linear-gradient(to bottom, #ff9966 0%, #66ff66 100%);
    cursor: pointer;
    color: rgb(20, 47, 136);
    font-weight: bolder;
    font-size: large;
}

/* separate styling for mobile devices */
@media all and (orientation: portrait) {
    h2 {
        padding: 3rem;
        padding-bottom: 0rem;
        font-size: xx-large;
    }

    p {
        margin-bottom: 2rem;
    }
}
</style>
